import Vue from 'vue';
import core, { CoreOptions } from '@glittr/frontend-core';
import router from './router';
import services from './services/v2';
import bvCustomerLookup from './components/lookups/bv-customer-lookup.vue';
import bvProductLookup from './components/lookups/bv-product-lookup.vue';
import bvSubtitleDialog from './components/forms/bv-subtitle-dialog.vue';
import bvProductList from './components/products/bv-product-list.vue';
import alert from './plugins/alert';
// import ilLanguageSelection from './components/il-language-selection.vue';

Vue.config.productionTip = false;
// Core entry point
Vue.use(core, {
  // appId: 'custom-mount-id'
  router,
  Vue,
  hasServiceWorker: true,
} as CoreOptions);

// APP____________________________________________________________

// STYLES
require('./assets/styles/main.scss');

// PLUGINS
Vue.use(services);
Vue.use(alert);

// COMPONENTS
// Vue.component('IlLanguageSelection', ilLanguageSelection);
Vue.component('BvCustomerLookup', bvCustomerLookup);
Vue.component('BvProductLookup', bvProductLookup);
Vue.component('BvSubtitleDialog', bvSubtitleDialog);
Vue.component('BvProductList', bvProductList);
// GUARDS
// Vue.$guards.push(yourGuard);

// LAYOUTS
const reqLayouts = require.context('./views/layouts', true);
reqLayouts.keys().forEach((componentPath) => {
  let componentName = componentPath.substr(componentPath.lastIndexOf('/') + 1, componentPath.length - 1);
  componentName = componentName.replace('.vue', '');
  const component = reqLayouts(componentPath).default;
  Vue.component(componentName, component);
});

// _______________________________________________________________

require('./store');

declare module '@core/plugins/config/config' {
  interface ConfigType {
    // add custom config props here
  }
}
